// Server-backed "already seen" state for the sidebar badges. It used to live
// in localStorage, i.e. per browser: opening a page on one laptop cleared the
// badge there only. Now it is stored per employee account on the server, so
// it follows the account across laptops.
import { userRequest } from "../RequestMethods";

// One-time move of the ids this browser had stored locally before the switch,
// so existing badges don't all light up again. Silently skipped on failure;
// the local key is only removed once the server has the ids.
const migrateLegacyIds = async (kind, legacyKey) => {
  let legacyIds = [];
  try {
    const raw = localStorage.getItem(legacyKey);
    legacyIds = raw ? JSON.parse(raw) : [];
  } catch {
    legacyIds = [];
  }

  if (Array.isArray(legacyIds) && legacyIds.length > 0) {
    await userRequest.post("notifications/seen", { kind, ids: legacyIds });
  }

  try {
    localStorage.removeItem(legacyKey);
  } catch {
    // localStorage unavailable - nothing to clean up
  }
};

export const fetchSeenIds = async (kind, legacyKey) => {
  try {
    await migrateLegacyIds(kind, legacyKey);
  } catch (err) {
    console.error("Could not move locally stored seen ids to the server:", err);
  }

  const res = await userRequest.get("notifications/seen", { params: { kind } });
  return new Set(res.data?.ids || []);
};

export const postSeenIds = async (kind, ids) => {
  if (!ids.length) return;
  await userRequest.post("notifications/seen", { kind, ids });
};
